import { View } from "binder"
import { ReportSelectionViewModel } from "./reportSelection-viewModel"

export class ReportSelectionView extends View<ReportSelectionViewModel>{
    GetViewUniqueId(): string {
        return "V-390922B5-FFA2-47B9-B3BC-6C3F543AFD69"
    }
    loadHtml(): string {
        let element = require('./reportSelection.html').default;
        let style = require('./reportSelection.less');
        return element;
    }
    constructor() {
       super();
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    
    edit(){
        this.dataContext.edit();
    }
}
